import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { usePostHog } from './PostHogProvider';
import { useApiAuth } from '../hooks/useApiAuth';
import axios from 'axios';
import config from '../config';
import './Contact.css';

const Contact = () => {
  const { user } = useAuth0();
  const { getAuthHeaders } = useApiAuth();
  const { posthog } = usePostHog();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  // Track page view when Contact component mounts
  useEffect(() => {
    // posthog.capture('contact_page_viewed', {
    //   distinct_id: user?.sub,
    //   email: user?.email,
    //   name: user?.name,
    //   timestamp: new Date().toISOString()
    // });
  }, [posthog, user]);

  const handleContactClick = async () => {
    if (!user?.email) {
      setError('Unable to get your email. Please try again.');
      
      // Track error when user email is not available
      // if (posthog) {
      //   posthog.capture('contact_error', {
      //     distinct_id: user?.sub,
      //     email: user?.email,
      //     name: user?.name,
      //     error: error.message,
      //     timestamp: new Date().toISOString()
      //   });
      // }
      return;
    }

    setIsSubmitting(true);
    setError(null);

    // Track contact form submission attempt
    // if (posthog) {
    //   posthog.capture('contact_form_submitted', {
    //     distinct_id: user?.sub,
    //     email: user?.email,
    //     name: user?.name,
    //     form_data: {
    //       name: formData.name,
    //       email: formData.email,
    //       subject: formData.subject,
    //       message_length: formData.message.length
    //     },
    //     timestamp: new Date().toISOString()
    //   });
    // }

    try {
      const authHeaders = await getAuthHeaders();
      await axios.post(
        `${config.apiUrl}/contact`,
        { 
          email: user.email,
          firstName: user.given_name || '',
          lastName: user.family_name || ''
        },
        {
          headers: authHeaders
        }
      );
      
      setIsSuccess(true);
      
      // Track successful contact submission
      // if (posthog) {
      //   posthog.capture('contact_form_success', {
      //     distinct_id: user?.sub,
      //     email: user?.email,
      //     name: user?.name,
      //     timestamp: new Date().toISOString()
      //   });
      // }
    } catch (error) {
      console.error('Error sending contact request:', error);
      setError('Failed to send contact request. Please try again.');
      
      // Track contact form error
      // if (posthog) {
      //   posthog.capture('contact_form_error', {
      //     distinct_id: user?.sub,
      //     email: user?.email,
      //     name: user?.name,
      //     error: error.message,
      //     timestamp: new Date().toISOString()
      //   });
      // }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <img 
          src="/ChatWDL_logo.png" 
          alt="ChatWDL Logo" 
          className="contact-logo"
        />
        {isSuccess ? (
          <>
            <h1>Thank You!</h1>
            <p>Thank you for reaching out. Someone will follow up shortly.</p>
          </>
        ) : (
          <>
            <h1>Question Limit Reached</h1>
            <p>You've reached the maximum number of questions in the free trial—because ChatWDL is so fracing awesome, we had to put a lid on it.</p>
            <p>Hit 'Contact Me' and we'll beam your info straight to our team—no pigeons, no paperwork.</p>

            {error && (
              <p className="error-message" style={{ color: 'var(--error-color)', marginTop: '1rem' }}>
                {error}
              </p>
            )}

            <div className="contact-actions">
              <button 
                onClick={handleContactClick} 
                className="logout-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Contact Me'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Contact; 